import { createFileRoute } from '@tanstack/react-router';
import {
  loadSimulationMessages,
  loadSimulationRenewalScreens,
  simulationInssRefinancingScreen,
} from '@/modules/simulation/route';
import { flowSearchSchema } from '@/shared/flow/define-flow';
import { lazyScreen } from '@/shared/screen/lazy-screen';

export const Route = createFileRoute('/_app/ccb/contratar/consignado-inss/refinanciamento/')({
  validateSearch: flowSearchSchema(),
  staticData: { screen: simulationInssRefinancingScreen },
  loader: () => loadSimulationMessages(),
  component: lazyScreen(loadSimulationRenewalScreens, 'InssRefinancingRouteScreen'),
});
